import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 22.72 23.07' {...props}>
    <g data-name='Layer 2'>
      <path
        fill='none'
        stroke='#4d4d4d'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={4}
        d='M2 9.96l8.37 11.11L20.72 2'
        data-name='general content'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/CheckMarkIcon.js